export const PRICE_TIERS = { retail: 199.99, wholesale: 99.99 };
export const PAGE_COUNTS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const DEFAULT_PACKAGE = {
  page_count: 20, price_tier: "retail", custom_unit_price: 199.99, markup_pct: 0, discount_pct: 0,
  delivery: "build", growth_rate_pct: 5, visits_per_page: 40, conversion_pct: 3, close_rate_pct: 30,
  avg_ticket: 350, ramp_months: 4, default_address_type: "path", include_in_proposal: true,
};

const r2 = (n) => Math.round(n * 100) / 100;
const r1 = (n) => Math.round(n * 10) / 10;

export const pricePackage = (c) => {
  const base = c.price_tier === "custom" ? Number(c.custom_unit_price) : PRICE_TIERS[c.price_tier];
  const unit = r2(base * (1 + Number(c.markup_pct) / 100));
  const subtotal = r2(unit * Number(c.page_count));
  const discount = r2(subtotal * Number(c.discount_pct) / 100);
  return { unit_price: unit, subtotal, discount, total: r2(subtotal - discount) };
};

// mirrors backend webadvisor_pages.simulate
export const simulate = (c, totalCost) => {
  let cum = 0;
  const months = Array.from({ length: 12 }, (_, i) => {
    const m = i + 1;
    const ramp = Math.min(1, m / Number(c.ramp_months));
    const growth = (1 + Number(c.growth_rate_pct) / 100) ** (m - 1);
    const visits = Math.round(Number(c.page_count) * Number(c.visits_per_page) * ramp * growth);
    const leads = r1(visits * Number(c.conversion_pct) / 100);
    const customers = r1(leads * Number(c.close_rate_pct) / 100);
    const revenue = r2(customers * Number(c.avg_ticket));
    cum += revenue;
    return { month: m, visits, leads, customers, revenue, cumulative_revenue: r2(cum) };
  });
  const totals = ["visits", "leads", "customers", "revenue"].reduce((a, k) => ({ ...a, [k]: r1(months.reduce((s, r) => s + r[k], 0)) }), {});
  const payback = totalCost ? (months.find(r => r.cumulative_revenue >= totalCost)?.month ?? null) : 1;
  const roi = totalCost ? Math.round((totals.revenue - totalCost) / totalCost * 100) : null;
  return { months, totals, payback_month: payback, roi_pct: roi };
};

export const money = (n) => `${Number(n) < 0 ? "−" : ""}$${Math.abs(Number(n || 0)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
